module.exports = __webpack_public_path__ + "static/media/basicPackageJson.f4c91362.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/basicPackageJson.png
// module id = 1535
// module chunks = 0